import React, { FC } from 'react';
import { ReactComponent as NoFiltersSvg } from 'assets/nofilters.svg';
import { Trans } from 'react-i18next';
import css from '../../styles.module.scss';

const EmtyBlock: FC = () => (
  <div className={css.empty}>
    <NoFiltersSvg />
    <span>
      <Trans i18nKey="reportbuilder.startInfo" components={{ br: <br /> }} />
    </span>
  </div>
);

export default EmtyBlock;
